import React from 'react';
import LoadingFade from "../../common/LoadingFade";
import {CircularProgress} from "@material-ui/core";

const SingleImagePendingSkeleton = () => (
  <LoadingFade loading={true}/>
);

export default SingleImagePendingSkeleton;
